import { render, staticRenderFns } from "./CreateData.vue?vue&type=template&id=3ead803c&scoped=true&"
import script from "./CreateData.ts?vue&type=script&lang=ts&"
export * from "./CreateData.ts?vue&type=script&lang=ts&"
import style0 from "./CreateData.scss?vue&type=style&index=0&id=3ead803c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead803c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
